import {Component} from '@angular/core';
import {TodoItem, TodoService} from '../../../services/todo/todo.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-payroll-dashboard',
  templateUrl: './payroll-dashboard.component.html',
  styleUrls: ['./payroll-dashboard.component.scss']
})
export class PayrollDashboardComponent {
  protected todoList;

  constructor(
      private todoService: TodoService,
      private router: Router,
  ) {
    this.todoList = todoService.getPendingItems();
  }

  itemClicked(item: TodoItem): void {
    this.router.navigate([item.page]);
  }

}
